// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import type Decimal from 'decimal.js';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { getID } from '../../utils';
import { Table } from '../common/table';
import type { ColumnType } from '../common/table/Table';
import OrderIdLink from './OrderIdLink';

interface CustomerData {
  readonly orderId?: string;
  readonly customer: string;
  readonly trays: Decimal;
}

interface Props {
  readonly orders: CustomerData[];
}

export default function CustomerTable({ orders }: Props) {
  const idValues: (React.ReactElement | string)[] = [];
  const customerValues: string[] = [];
  const traysValues: string[] = [];

  const surpluses = orders.filter((order) => order.orderId === undefined);
  for (const order of orders) {
    if (order.orderId === undefined) {
      // do nothing
    } else {
      const gotId = getID(order.orderId);
      idValues.push(<OrderIdLink id={gotId} />);
      customerValues.push(order.customer ?? '-');
      traysValues.push(order.trays.toFixed(2));
    }
  }
  for (const order of surpluses) {
    idValues.push('-');
    customerValues.push('Surplus');
    traysValues.push(order.trays.toFixed(2));
  }
  const columns: ColumnType[] = [
    {
      name: 'Order',
      values: idValues,
    },
    {
      name: 'Customer',
      values: customerValues,
    },
    {
      name: 'Trays',
      values: traysValues,
      numeric: true,
    },
  ];

  return <Table columns={columns} />;
}
